var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hailingStatusModal__popup hailingStatusModal__popup--fail"},[_c('BaseConfirmModal',{attrs:{"title":_vm.repeatedMsg,"confirmBtnText":'確定',"cancelBtnText":'取消'},on:{"confirm":function($event){return _vm.$emit('confirmRepeated')},"cancel":function($event){return _vm.$emit('cancelRepeated')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }